export default "__VITE_ASSET__64430904__"